import React from "react";
import { GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { SCHEDULETYPE, HEADERTYPE } from "../../../constant/constant";

export const HeaderTypeCell = (props) => {
  const dataItem = props.dataItem || {};
  const isHeader = dataItem.Type == SCHEDULETYPE.Header;

  let displayValue = "";

  if (isHeader) {
    const val = (dataItem.HeaderType !== undefined && dataItem.HeaderType !== null)
      ? dataItem.HeaderType
      : (props.field ? dataItem[props.field] : null);

    if (val === HEADERTYPE.ProgramScheduleSlot || val === "ProgramScheduleSlot" || val === 2) {
      displayValue = "ProgramScheduleSlot";
    } else if (val === HEADERTYPE.ProgramSchedule || val === "ProgramSchedule" || val === 1) {
      displayValue = "ProgramSchedule";
    } else if (dataItem.ProgramScheduleSlot && (dataItem.ProgramScheduleSlot._id || dataItem.ProgramScheduleSlot.Description)) {
      displayValue = "ProgramScheduleSlot";
    } else {
      displayValue = "ProgramSchedule";
    }
  }

  return (
    <td
      colSpan={props.colSpan}
      style={{
        ...props?.style,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
      }}
      role={"gridcell"}
      aria-colindex={props.ariaColumnIndex}
      aria-selected={props.isSelected}
      {...{
        [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex,
      }}
      {...useTableKeyboardNavigation(props.id)}
      title={isHeader ? displayValue : ""}
    >
      {isHeader ? displayValue : ""}
    </td>
  );
};
